import { Link } from 'react-router-dom';

export default function HomeHero() {
  return (
    <section className="relative h-[420px] md:h-[560px] w-full flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20composition%20with%20soft%20blooming%20rose%20pink%20and%20warm%20golden%20hues%2C%20flowing%20organic%20curves%2C%20minimalist%20design%2C%20dreamy%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20gentle%20gradient%20transitions%2C%20luxurious%20yet%20subtle%20feel%2C%20editorial%20photography%20style%20with%20soft%20focus%20and%20elegant%20composition&width=1600&height=800&seq=home-hero-01&orientation=landscape"
          alt="爱情岛论坛网址导航"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
      </div>
      <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
          爱情岛论坛网址
          <br />
          <span className="text-primary-300">官方入口导航与最新地址</span>
        </h1>
        <p className="text-white/75 text-sm md:text-lg mb-8 max-w-xl mx-auto leading-relaxed">
          专注收录爱情岛论坛网址的最新官方入口，提供稳定可访问的地址导航、最新线路更新与使用指南
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/zuixin-dizhi"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看最新地址
          </Link>
          <Link
            to="/category/shiyong-zhinan"
            className="px-6 py-3 bg-white/15 text-white rounded-lg font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            查看使用指南
          </Link>
        </div>
        <div className="flex items-center justify-center gap-4 mt-8 text-xs text-white/60">
          <span className="flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-green-400"></span>
            主线路正常
          </span>
          <span className="flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-green-400"></span>
            备用线路正常
          </span>
          <span className="flex items-center gap-1">
            <span>更新时间：2026-08-05</span>
          </span>
        </div>
      </div>
    </section>
  );
}